import { useParams } from 'react-router-dom';
import { Button, Heading, enums as e, Icon, Pill, utils as u } from 'edrolo-ui';
import urlResolver from 'edrolo/utils/URLResolver';
import s from './styles.scss';
import cx from 'classnames';

interface SubmitWarningModalProps {
  setIsModalClosed: (isClose: boolean) => void;
  notAnswered: number;
  submitTask?: () => void;
}

export const SubmitWarningModal = ({
  setIsModalClosed,
  notAnswered,
  submitTask,
}: SubmitWarningModalProps) => {
  const { taskId } = useParams<{ taskId: string }>();

  return (
    <div className={s.submitWarningModal}>
      <header>
        <Pill
          size={e.Size.LARGE}
          variant={e.PillVariant.CIRCLE}
          color={e.ColorHue.RED}
        >
          <Icon size={e.Size.LARGE} name={e.Icons.RISK_ASSESS} />
        </Pill>
      </header>

      <section>
        <Heading.Display className={cx(u.red4, u.mb2)} level={2}>
          {`${notAnswered} unanswered questions`}
        </Heading.Display>
        <p className={u.mb0}>
          Are you sure you want to submit this task? Once submitted, no
          additional question responses can be added.
        </p>
      </section>

      <footer className={cx(u.flex, u.gap2)}>
        <Button.Link
          color={e.ColorTheme.BACKGROUND}
          size={e.Size.LARGE}
          to={urlResolver.reverse('tasks-page')}
          onClick={() => {
            submitTask && submitTask();
            setIsModalClosed(true);
          }}
        >
          Submit anyway
        </Button.Link>

        <Button.Link
          color={e.ColorTheme.SECONDARY}
          size={e.Size.LARGE}
          to={urlResolver.reverse('task-page', { taskId })}
          onClick={() => {
            setIsModalClosed(true);
          }}
        >
          No, review questions
        </Button.Link>
      </footer>
    </div>
  );
};
